/* Cancelation Score circle directive */
App.directive('pctComplete1', function() {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            value: '='
        },
        template: ' <div class="c100 p{{value}} small blue">'+
        '<span style="color:#72c800">{{value}}%</span>'+
        '<div class="slice">'+
        ' <div class="bar" style="border:0.08em solid #72c800;"></div>'+
        '<div class="fill" ng-if="value <= 50"></div>'+
        '<div class="fill" ng-if="value > 50" style="border:0.08em solid #72c800;"></div>'+
        '</div>'+
        '</div>'
    };
});

App.directive('pctComplete', function() {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            value: '='
        },
        template: ' <div class="c100 p{{value}} small blue">'+
        '<span>{{value}}%</span>'+
        '<div class="slice">'+
        ' <div class="bar"></div>'+
        '<div class="fill"></div>'+
        '</div>'+
        '</div>'
    };
});